import apiClient from 'lib/apiClient';

export const getCallers = (params) =>
  apiClient.get('/API/1_0/caller.php', {
    params,
  });

export const getCaller = (hash) =>
  apiClient
    .get('/API/1_0/caller.php', {
      params: {
        hash,
      },
    })
    .then((resp) => resp[0]);

export const saveContactCaller = (data) =>
  apiClient.post('/API/1_0/caller.php', data);

export const deleteCaller = (hash) =>
  apiClient.delete('/API/1_0/caller.php', {
    params: {
      hash,
    },
  });

export const getTeams = async (params) => {
  const [teams, teamToCaller] = await Promise.all([
    apiClient.get('/API/1_0/callerTeam.php', {
      params,
    }),
    apiClient.get('/API/1_0/callerTeamToCaller.php', {
      params,
    }),
  ]);
  return teams.map((team) => {
    team.callers = teamToCaller.filter(
      (t) => t.caller_team_id === team.caller_team_id,
    );
    return team;
  });
};

export const getTeam = (hash) =>
  apiClient.get(`/API/1_0/callerTeam.php?hash=${hash}`).then((resp) => resp[0]);

export const saveTeam = (data) =>
  apiClient.post('/API/1_0/callerTeam.php', data);

export const deleteTeam = (hash) =>
  apiClient.delete('/API/1_0/callerTeam.php', {
    params: {
      hash,
    },
  });

export const getTeamCallers = (caller_team_id) =>
  apiClient.get('/API/1_0/callerTeamToCaller.php', {
    params: {
      caller_team_id,
    },
  });

export const addTeamMember = (data) =>
  apiClient.post('/API/1_0/callerTeamToCaller.php', data);

export const removeTeamMember = (hash) =>
  apiClient.delete('/API/1_0/callerTeamToCaller.php', {
    params: {
      hash,
    },
  });

export const getReceptionists = (params) =>
  apiClient
    .get('/API/1_0/digitalReceptionist.php', {
      params,
    })
    .then((resp) => {
      return resp.map((i) => {
        if (i.primary_digital_receptionist_menu) {
          i.primary_digital_receptionist_menu.digital_receptionist_menu_actions_after_speech =
            JSON.parse(
              i.primary_digital_receptionist_menu
                .digital_receptionist_menu_actions_after_speech,
            );
        }
        return i;
      });
    });

export const getReceptionist = (query) =>
  apiClient
    .get('/API/1_0/digitalReceptionist.php', {
      params: query,
    })
    .then((resp) => {
      const result = resp[0];
      if (result?.primary_digital_receptionist_menu) {
        result.primary_digital_receptionist_menu.digital_receptionist_menu_actions_after_speech =
          JSON.parse(
            result.primary_digital_receptionist_menu
              .digital_receptionist_menu_actions_after_speech,
          );
      }
      return result;
    });

export const saveReceptionist = (data) =>
  apiClient.post('/API/1_0/digitalReceptionist.php', data);

export const deleteReceptionist = (hash) =>
  apiClient.delete('/API/1_0/digitalReceptionist.php', {
    params: {
      hash,
    },
  });

export const getCallHistory = (query) =>
  apiClient.get('/API/1_0/call.php', { params: query });

export const getCallMenuOption = (hash) =>
  apiClient
    .get('/API/1_0/callMenuOptions.php', { params: { hash } })
    .then((resp) => resp[0]);

export const deleteCallMenuOption = (hash) =>
  apiClient.delete('/API/1_0/callMenuOptions.php', {
    params: {
      hash,
    },
  });

export const getCallMenuOptions = (query) =>
  apiClient
    .get('/API/1_0/digitalReceptionistMenu.php', { params: query })
    .then((resp) => {
      return resp.map((i) => {
        if (
          typeof i.digital_receptionist_menu_actions_after_speech === 'string'
        ) {
          i.digital_receptionist_menu_actions_after_speech = JSON.parse(
            i.digital_receptionist_menu_actions_after_speech,
          );
        }
        return i;
      });
    });

export const saveCallMenuOption = (data) =>
  apiClient.post('/API/1_0/callMenuOptions.php', data);

export const getCallMenus = (query) =>
  apiClient
    .get('/API/1_0/digitalReceptionistMenu.php', { params: query })
    .then((resp) => {
      return resp.map((i) => {
        if (
          typeof i.digital_receptionist_menu_actions_after_speech === 'string'
        ) {
          i.digital_receptionist_menu_actions_after_speech = JSON.parse(
            i.digital_receptionist_menu_actions_after_speech,
          );
        }
        return i;
      });
    });

export const getCallMenu = (hash) =>
  apiClient
    .get('/API/1_0/digitalReceptionistMenu.php', {
      params: { hash },
    })
    .then((resp) => {
      const menu = resp[0];
      if (menu) {
        if (
          typeof menu.digital_receptionist_menu_actions_after_speech ===
          'string'
        ) {
          menu.digital_receptionist_menu_actions_after_speech = JSON.parse(
            menu.digital_receptionist_menu_actions_after_speech,
          );
        }
      }
      return menu;
    });

export const saveCallMenu = (data) =>
  apiClient.post('/API/1_0/digitalReceptionistMenu.php', data).then((menu) => {
    if (
      typeof menu.digital_receptionist_menu_actions_after_speech === 'string'
    ) {
      menu.digital_receptionist_menu_actions_after_speech = JSON.parse(
        menu.digital_receptionist_menu_actions_after_speech,
      );
    }
    return menu;
  });

export const deleteCallMenu = (hash) =>
  apiClient.delete('/API/1_0/digitalReceptionistMenu.php', {
    params: { hash },
  });

export const uploadMedia = (file, params) => {
  const formData = new FormData();
  formData.append('media_file', file);

  return apiClient.post(`API/1_0/postMedia.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params,
  });
};

export const getVoiceMails = (query) =>
  apiClient.get('/API/1_0/callVoicemail.php', { params: query });

export const updateVoiceMail = (data) =>
  apiClient.post('/API/1_0/callVoicemail.php', data);

export const deleteVoiceMail = (hash) =>
  apiClient.delete('/API/1_0/callVoicemail.php', { params: { hash } });

export const gettextAudioUrl = (text, voice) =>
  apiClient
    .post('/API/1_0/callMenus.php', {
      text_to_speech_sample_text: text,
      voice,
    })
    .then((r) => r.sampleUrl);

// manage voice mails (Mark as New, Call Back, Text Back, Delete);
export const initCallBack = (data) =>
  apiClient.post('/API/1_0/callerCallouts.php', data);

export const initTextBack = (query) => {
  apiClient.get('/API/1_0/IVRHome.php', { params: query }).then((res) => res);
};

export const getCallHours = (query) =>
  apiClient.get('/API/1_0/callHour.php', { params: query });
export const saveCallHour = (data) =>
  apiClient.post('/API/1_0/callHour.php', data);

export const deleteCallHour = (hash) =>
  apiClient.delete('/API/1_0/callHour.php', { params: { hash } });

export const getCallActions = (accountId, callId) =>
  apiClient.get(`/API/1_0/callAction.php`, {
    params: { account_id: accountId, call_id: callId },
  });

export const getOperators = () => apiClient.get('/API/1_0/getOperators.php');

export const callAddPerson = (caller_hash, CallSid, isConf) =>
  apiClient.post('/API/1_0/callAddPerson.php', {
    caller_hash,
    CallSid,
    is_conference: isConf ? 1 : 0,
  });
